import React, { useContext, useEffect, useState } from 'react';
import classes from './CategoryCard.module.scss';
import { CategoryBorderCard } from '../../../../components/containers/CategoryBorderCard';
import { ContainerListItem } from '../../../../components/actions/ListItem/ListItem.view';
import classNames from 'classnames';
import { DeleteCategoryModal } from '../DeleteCategoryModal';
import { CreateEditCategoryModal } from '../CreateEditCategoryModal';
import { GetCategories_workspace_categories } from '../../../../models/legacy-graphql';
import { UnarchiveCategoryModal } from '../UnarchiveCategoryModal';
import { Icon } from '../../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../../constants/icons';
import { Void } from '../../../../models/basic-objects';
import { SquareButtonIconsEnum } from '../../../../constants/square-button-icons';
import { ButtonMenu } from '../../../../components/actions/ButtonMenu';
import { Badge } from 'components/containers/Badge';
import { BadgeColorsEnum, BadgeSizesEnum } from 'constants/badge';
import { ContainerListItemExtended } from '../../../../components/actions/ButtonMenu/ButtonMenu.view';
import { useLocation, useNavigate } from 'react-router-dom';
import { OnboardingContext } from '../../../Onboarding/states/OnboardingProvider';
import { getToolTip } from '../../../Onboarding/helpers/onboardingGetters';
import { useUserData } from '../../../../hooks/useUserData';
// import { TourTip } from '../../../Onboarding/TourTip';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { DEMO_CATEGORY_NAME, OnboardingStaticContent } from '../../../Onboarding/constants/content';
import { Debugger } from '../../../../components/containers/Debugger';

export type CategoryCardViewProps = {
  isFirst?: boolean;
  category: GetCategories_workspace_categories;
  openDeleteCategoryModal: boolean;
  setOpenDeleteCategoryModal: (open: boolean) => void;
  openEditCategoryModal: boolean;
  setOpenEditCategoryModal: (open: boolean) => void;
  openUnArchiveCategoryModal: boolean;
  setOpenUnArchiveCategoryModal: (open: boolean) => void;
  unArchiveCategoryHandler: VoidFunction;
  archiveDeleteCategoryHandler: Void;
  isLastCategory?: boolean;
  isPaused?: boolean;
  isAllSocialProfilesPaused?: boolean;
  timeslotCount: number;
  postsCount: number;
};

export const CategoryCardView = (props: CategoryCardViewProps): JSX.Element => {
  const breakpoint = useBreakpoints();
  const [toutipArticlesXY, setToutipArticlesXY] = useState<{ top: number; left: number } | null>(null);
  const [_tourtipDemoXY, setTourtipDemoXY] = useState<{ top: number; left: number } | null>(null);
  const { userData } = useUserData();
  const { id: userId, onboarding } = userData || {};
  const { stepsSeen } = onboarding || {};
  const { pathname: currentPath } = useLocation();
  const { state, showTourTips, showOnboarding } = useContext(OnboardingContext);
  const { version } = state;
  let key1: string = '';
  let key2: string = '';
  const disableDelete = OnboardingStaticContent[`v${version}`].disableDelete.categories;
  if (currentPath === '/publish/categories' && showTourTips && stepsSeen) {
    switch (version) {
      case 1:
      default: {
        if (props.isFirst) {
          key1 = 'v1_tourtip_categories_articles';
        }
        if (props.category.name === DEMO_CATEGORY_NAME) {
          key2 = `v1_tourtip_categories_demo`;
        }
        break;
      }
    }
  }
  const _toolTipDemo = key2 ? getToolTip(key2, state.progress) : null;
  const cardClasses = classNames('grid-x align-justify', {
    [classes.CategoryCard]: !props.category.archived,
    [classes.CategoryCardArchived]: props.category.archived
  });
  const cardBodyClasses = classNames('cell', {
    'margin-bottom-small-8': !props.category.archived
  });
  const navigate = useNavigate();
  const hasArchivedPosts = !(props.category?.archivedAttachedPostCount === 0);
  const archiveDeleteAction = props.category.archived
    ? {
        label: 'Delete',
        ...(hasArchivedPosts
          ? {
              disabled: true,
              disabledTooltipText: `This category cannot be deleted as it contains ${props.category.archivedAttachedPostCount} posts`
            }
          : {})
      }
    : { label: 'Archive' };

  const listItems: Array<ContainerListItem | ContainerListItemExtended> = [
    {
      action: () => props.setOpenEditCategoryModal(true),
      label: 'Edit'
    },
    {
      action: () => props.archiveDeleteCategoryHandler(),
      ...archiveDeleteAction,
      ...(props.category.onboardingContent && showOnboarding && disableDelete
        ? { disabled: true, disabledTooltipText: 'You’ll be able to archive these demo Categories later.' }
        : {})
    }
  ];

  if (props.category.archived) {
    listItems.splice(1, 0, {
      action: () => props.unArchiveCategoryHandler(),
      label: 'Unarchive'
    });
  }

  const isInSeason = !props.category.seasonallyPaused;
  // Format the dates to be able to work with them
  const seasonalStartDate = props.category.seasonalStartDate?.replace('--', '');
  const seasonalEndDate = props.category.seasonalEndDate?.replace('--', '');

  const badges: JSX.Element[] = [];
  // Badge(s) to be shown
  // The only time 2 badges can be rendered, is for an Archived Seasonal category
  if (props.category.archived) {
    badges.push(<Badge color={BadgeColorsEnum.GREY20} size={BadgeSizesEnum.LARGE} text={'Archived'} />);
    if (props.category.seasonal) {
      badges.push(<Badge color={BadgeColorsEnum.GREY20} size={BadgeSizesEnum.LARGE} text={'Seasonal'} />);
    }
  } else if (props.isPaused) {
    const badgeText = props.isAllSocialProfilesPaused ? 'paused' : 'part-paused';
    badges.push(
      <Badge
        color={BadgeColorsEnum.RED20}
        size={BadgeSizesEnum.LARGE}
        text={badgeText}
        clickHandler={() => navigate({ pathname: '/settings/pause' })}
        shrinkContent
      />
    );
    if (props.category.seasonal) {
      badges.push(<Badge color={BadgeColorsEnum.GREY20} size={BadgeSizesEnum.LARGE} text={'Seasonal'} />);
    }
  } else if (props.category.seasonal) {
    badges.push(
      <Badge
        color={isInSeason ? BadgeColorsEnum.GREEN15 : BadgeColorsEnum.GREY20}
        size={BadgeSizesEnum.LARGE}
        text={isInSeason ? 'Active In Season' : 'Out of Season'}
      />
    );
  }

  useEffect(() => {
    setToutipArticlesXY(null);
    setTourtipDemoXY(null);
  }, [breakpoint]);

  return (
    <CategoryBorderCard
      borderColor={props.category.color}
      borderPosition={'Left'}
      applyCardBorder={true}
      ref={ref => {
        if (key1 && ref && userId && !toutipArticlesXY) {
          const { width, height } = ref.getBoundingClientRect();
          setToutipArticlesXY({ top: height / 2 - 8, left: width / 2 - 8 }); // pulsing dot is 16x16px 8 is 1/2
        }
      }}>
      <div className={cardClasses}>
        <Debugger tooltipContent={'Category ID: ' + props.category.id} modalContent={props.category} />
        <div className={`${cardBodyClasses}`}>
          <h4
            ref={_ref => {
              // TODO disabled for the initial ONboarding test
              // if (key2 && ref && userId && !tourtipDemoXY) {
              //   const { height } = ref.getBoundingClientRect();
              //   setTourtipDemoXY({ top: height + 16, left: 10 });
              // }
            }}
            className={'one-liner margin-bottom-small-12'}>
            {props.category.name}
          </h4>
          <div className={classNames('grid-x margin-top-small-8', classes.BadgeGroup)}>
            {badges.map(badge => {
              return (
                <div
                  key={badge.key}
                  className={classNames(classes.BadgeMargin, {
                    [classes.BadgePartPaused]: badge.key === 'part-paused' && props.category.seasonal
                  })}>
                  {badge}
                </div>
              );
            })}
            <div className={classes.SeasonDates}>
              {seasonalStartDate && seasonalEndDate && (
                <>
                  <span className={classes.ScheduleIcon}>
                    <Icon name={IconsEnum.multidate} size={'medium'} />
                  </span>
                  <span className={classes.SeasonalDates}>
                    <h6>{`${seasonalStartDate.replace('-', '.')} - ${seasonalEndDate.replace('-', '.')}`}</h6>
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.DotMenu}>
        <ButtonMenu
          isSquareButton={true}
          buttonType={'transparent'}
          listItems={listItems}
          side={'right'}
          icon={SquareButtonIconsEnum.dotsShifted}
        />
      </div>
      {!props.category.archived && (
        <div className={classes.StatusTable}>
          <h6 className={classes.StatusItem}>{`${props.timeslotCount} Timeslots`}</h6>
          <h6 className={classes.StatusItem}>{props.postsCount} Active Posts</h6>
        </div>
      )}
      {props.openDeleteCategoryModal && (
        <DeleteCategoryModal
          onClose={() => props.setOpenDeleteCategoryModal(false)}
          categoryId={props.category.id}
          isArchived={props.category.archived}
        />
      )}
      {props.openEditCategoryModal && (
        <CreateEditCategoryModal onClose={() => props.setOpenEditCategoryModal(false)} category={props.category} />
      )}
      {props.openUnArchiveCategoryModal && (
        <UnarchiveCategoryModal
          onClose={() => props.setOpenUnArchiveCategoryModal(false)}
          categoryId={props.category.id}
        />
      )}
      {/*{key1 && toutipArticlesXY ? (*/}
      {/*  <TourTip*/}
      {/*    id={key1}*/}
      {/*    tooltipPointerPosition={'TopCenter'}*/}
      {/*    offsetY={toutipArticlesXY.top}*/}
      {/*    offsetX={toutipArticlesXY.left}*/}
      {/*    offsetFromDotY={toutipArticlesXY.top}*/}
      {/*  />*/}
      {/*) : null}*/}
      {/*{key2 && tourtipDemoXY ? (*/}
      {/*  <TourTip*/}
      {/*    id={key2}*/}
      {/*    tooltipPointerPosition={'TopLeft'}*/}
      {/*    offsetX={tourtipDemoXY.left}*/}
      {/*    offsetY={tourtipDemoXY.top}*/}
      {/*    offsetFromDotY={-8}*/}
      {/*  />*/}
      {/*) : null}*/}
    </CategoryBorderCard>
  );
};
